import { env_variables } from "./env";
// import httpClient from 'react-http-client';
// let httpClient = require("./httpClient");
import HttpHandler from "./httpHandler";
// let token = (sessionStorage.getItem("userData"));
// let optionalHeaders = {
//   Authorization: token ? `Bearer ${token?.token}` : "",
// };

export const geturl = (url, key) => {
  console.log("Process env: ", process.env.REACT_APP_ADMIN_API_URL);
  if (key == "admin") {
    return `${process.env.REACT_APP_ADMIN_API_URL}/${url}`;
  } else if (key == "borrower") {
    return `${process.env.REACT_APP_BORROWER_API_URL}/${url}`;
  }
};

export const AuthPost = async (url, body, key) => {
  let token;
  if (key == "admin") {
    token = sessionStorage.getItem("admin_token");
  } else if (key == "borrower") {
    token = sessionStorage.getItem("borrower_token");
  }
  let optionalHeaders = {
    Authorization: token ? `Bearer ${token}` : "",
  };

  let activeUrl = geturl(url, key);
  let data = await HttpHandler.post(activeUrl, body, optionalHeaders);
  // console.log(data);
  return data;
};

export const AuthPatch = async (url, body, key) => {
  let token;
  if (key == "admin") {
    token = sessionStorage.getItem("admin_token");
  } else if (key == "borrower") {
    token = sessionStorage.getItem("borrower_token");
  }
  let optionalHeaders = {
    Authorization: token ? `Bearer ${token}` : "",
  };

  let activeUrl = geturl(url, key);
  let data = await HttpHandler.patch(activeUrl, body, optionalHeaders);
  // console.log(data);
  return data;
};

export const AuthGet = async (url, key) => {
  let token;
  if (key == "admin") {
    token = sessionStorage.getItem("admin_token");
  } else if (key == "borrower") {
    token = sessionStorage.getItem("borrower_token");
  }
  let UserId = sessionStorage.getItem("UserId");
  console.log("u",UserId);
  let optionalHeaders = {
    Authorization: token ? `Bearer ${token}` : "",
    UserId: UserId ? UserId : "",
  };

  let activeUrl = geturl(url, key);
  //console.log(url);
  let data = await HttpHandler.get(activeUrl, "", optionalHeaders);
  // console.log(data);
  return data;
};

export const Get = async (url, key) => {
  let activeUrl = geturl(url, key);
  let data = await HttpHandler.get(activeUrl, "", {});
  return data;
};

export const Post = async (url, body, key) => {
  //console.log(url);
  let activeUrl = geturl(url, key);
  //console.log(activeUrl);
  let data = await HttpHandler.post(activeUrl, body, {});
  // console.log(data);
  return data;
};

export const AuthPut = async (url, body, key) => {
  let token;
  if (key == "admin") {
    token = sessionStorage.getItem("admin_token");
  } else if (key == "borrower") {
    token = sessionStorage.getItem("borrower_token");
  }
  let UserId = sessionStorage.getItem("UserId");
  let optionalHeaders = {
    Authorization: token ? `Bearer ${token}` : "",
  };
  //console.log(url);
  let activeUrl = geturl(url, key);
  let data = await HttpHandler.put(activeUrl, body, optionalHeaders);
  // console.log(data);
  return data;
};

export const AuthFile = async (url, body, key, method = "post") => {
  let token;
  if (key == "admin") {
    token = sessionStorage.getItem("admin_token");
  } else if (key == "borrower") {
    token = sessionStorage.getItem("borrower_token");
  }

  let activeUrl = geturl(url, key);
  if (method === "post") {
    let data = await HttpHandler.post(activeUrl, body, {
      "content-type": "multipart/form-data",
      Authorization: token ? `Bearer ${token}` : "",
    });
    return data;
  } else if (method === "patch") {
    let data = await HttpHandler.patch(activeUrl, body, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
    return data;
  }
};
